import { createSlice } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { persistReducer } from 'redux-persist';

const sidebarSlice = createSlice({
    name: 'sidebar',
    initialState: {
        isOpen: true
    },
    reducers: {
        toggleSidebar(state) {
            state.isOpen = !state.isOpen;
        },
        openSidebar(state) {
            state.isOpen = true;
        },
        closeSidebar(state) {
            state.isOpen = false;
        }
    }
});

const sidebarReducer = persistReducer(
    {
        key: 'rtk:sidebarSlice',
        storage,
        whitelist: ['isOpen']
    },
    sidebarSlice.reducer
);

const reducerObj = { reducerPath: sidebarSlice.name, reducer: sidebarReducer };

export const { toggleSidebar, openSidebar, closeSidebar } = sidebarSlice.actions;

export default reducerObj;
